import Configuration from '../models/configuration'
import {generateRouteFromPage} from "../components/routes";

export default {
    data() {
        return {
            $hover: {
                menuItem: false,
                musicContainer: false,
                itemPlayButton: false,
                beatLicense: false,
                licenseRow: false,
                discountContainer: false
            },
            $active: {
                musicContainer: false,
                discountContainer: false
            },
            $display: null,
            $highlightedLicense: false,
            $configLoading: false,
            $hasReset: false
        }
    },
    watch: {
        '$store.state.configure'(val) {
            this.$configure = val;
        }
    },
    computed: {
        $configure:{
            get: function() {
                return this.$store.state.configure
            },
            set: function(newValue) {
                return newValue
            }
        },
        $currentConfig() {
            return this.$store.state.currentConfig
        },
        $styleConfig() {
            return this.$currentConfig.stylesConfig
        },
        $mainBodyStyle() {
            if (this.$styleConfig && this.$styleConfig.main.background != undefined && this.$styleConfig.main.primary_text != undefined) {
                return {
                    'background': this.$styleConfig.main.background.value,
                    'color': this.$styleConfig.main.primary_text.value,
                }
            }

            return {}
        },
        $heroTitle() {
            if (this.$styleConfig && this.$styleConfig.main.hero_title != undefined) {
                return {
                    color: this.$styleConfig.main.hero_title.value
                }
            }
            return {}
        },
        $highlightColor() {
            if (this.$styleConfig && this.$styleConfig.main.highlight_color != undefined) {
                return {
                    color: this.$styleConfig.main.highlight_color.value
                }
            }
            return {}
        },
        $backgroundHighlightColor() {
            if (this.$styleConfig && this.$styleConfig.main.highlight_color != undefined) {
                return {
                    backgroundColor: this.$styleConfig.main.highlight_color.value,
                }
            }
            return {
                backgroundColor: '#8f40b0',
            }
        },
        $mainPrimaryTextStyle() {
            if (this.$styleConfig && this.$styleConfig.main.primary_text != undefined) {
                return {
                    color: this.$styleConfig.main.primary_text.value
                }
            }

        },
        $mainSecondaryTextStyle() {
            if (this.$styleConfig && this.$styleConfig.main.secondary_text != undefined) {
                return {
                    color: this.$styleConfig.main.secondary_text.value
                }
            }
            return {}
        },
        $mainTertiaryTextStyle() {
            if (this.$styleConfig && this.$styleConfig.main.tertiary_text != undefined) {
                return {
                    color: this.$styleConfig.main.tertiary_text.value
                }
            }
            return {}
        },
        $genreStyle() {
            let shadeValue = this.isDarkColor(this.$styleConfig.main.background.value) ? 0.2 : -0.2
            let color = this.shadeColor(this.$styleConfig.main.background.value, shadeValue)

            return {
                color: color
            }
        },
        $mainButtonStyle() {
            if (this.$styleConfig && this.$styleConfig.main.button_background != undefined && this.$styleConfig.main.button_text != undefined) {
                return {
                    background: this.$styleConfig.main.button_background.value,
                    color: this.$styleConfig.main.button_text.value
                }
            }
        },
        $itemPlayButtonStyle() {
            if (this.$styleConfig && this.$styleConfig.main.play_button_background != undefined && this.$styleConfig.main.play_button_icon != undefined) {
                return {
                    'background': this.$styleConfig.main.play_button_background.value,
                    'border-color': this.$styleConfig.main.play_button_background.value,
                    'color': this.$styleConfig.main.play_button_icon.value
                }
            }
        },
        $playButtonStandalone() {
            if (this.$styleConfig && this.$styleConfig.main.play_button_background != undefined && this.$styleConfig.main.play_button_icon != undefined) {
                return {
                    'background': this.$styleConfig.main.play_button_icon.value,
                    'border-color': this.$styleConfig.main.play_button_icon.value,
                    'color': this.$styleConfig.main.play_button_background.value
                }
            }
        },
        $beatLicensePriceStyle() {
            if (this.$styleConfig && this.$styleConfig.main.license_discounts_button_background != undefined) {
                return {
                    color: this.$styleConfig.main.license_discounts_button_background.value
                }
            }
        },
        $itemTileStyle() {
            if (this.$styleConfig && this.$styleConfig.main.item_tile_background != undefined && this.$styleConfig.main.item_tile_primary_text != undefined && this.$styleConfig.main.item_tile_border != undefined) {
                return {
                    'background-color': this.$styleConfig.main.item_tile_background.value,
                    'color': this.$styleConfig.main.item_tile_primary_text.value,
                    'border-color': this.$styleConfig.main.item_tile_border.value,
                }
            }
        },
        $itemTileSecondaryTextStyle() {
            if (this.$styleConfig && this.$styleConfig.main.item_tile_secondary_text != undefined) {
                return {
                    'color': this.$styleConfig.main.item_tile_secondary_text.value
                }
            }
        },
        $itemTilePriceStyle() {
            if (this.$styleConfig && this.$styleConfig.main.item_tile_price !== undefined && this.$styleConfig.main.item_tile_price_background !== undefined) {
                return {
                    'color': this.$styleConfig.main.item_tile_price.value,
                    'background-color': this.$styleConfig.main.item_tile_price_background.value
                }
            }
        },
        $itemTileBorderStyle() {
            if(this.$styleConfig.main.item_tile_border != undefined) {
                return {
                    'border-color': this.$styleConfig.main.item_tile_border.value,
                }
            }
        },
        $itemTileBorderHex() {
            let shadeValue = this.isDarkColor(this.$styleConfig.main.item_tile_background.value) ? 0.1 : -0.1
            let borderColor = this.shadeColor(this.$styleConfig.main.item_tile_background.value, shadeValue)

            return borderColor
        },
        $rowItemStyle() {
            if (this.$styleConfig && this.$data.$display == 'list') {
                if (this.$data.$active.musicContainer && this.$styleConfig.main.row_active_background) {
                    return {
                        background: this.$styleConfig.main.row_active_background.value,
                        color: this.$styleConfig.main.row_active_secondary_text.value
                    }
                }

                if (this.$data.$hover.musicContainer && this.$styleConfig.main.row_hover_background) {
                    return {
                        background: this.$styleConfig.main.row_hover_background.value,
                        color: this.$styleConfig.main.row_hover_secondary_text.value
                    }
                }

                if (this.$styleConfig.main.tertiary_text) {
                    return {
                        color: this.$styleConfig.main.tertiary_text.value
                    }
                }
            }

            return {}
        },
        $rowItemHighlightTextStyle() {
            if (this.$styleConfig) {
                if (this.$data.$active.musicContainer && this.$styleConfig.main.row_active_primary_text) {
                    return {
                        color: this.$styleConfig.main.row_active_primary_text.value
                    }
                }

                if (this.$data.$hover.musicContainer && this.$styleConfig.main.row_hover_primary_text) {
                    return {
                        color: this.$styleConfig.main.row_hover_primary_text.value
                    }
                }

                if (this.$styleConfig.main.primary_text) {
                    return {
                        color: this.$styleConfig.main.primary_text.value
                    }
                }
            }
        },
        $rowItemMainTextStyle() {
            if (this.$styleConfig) {
                if (this.$data.$active.musicContainer && this.$styleConfig.main.row_active_secondary_text) {
                    return {
                        color: this.$styleConfig.main.row_active_secondary_text.value
                    }
                }

                if (this.$data.$hover.musicContainer && this.$styleConfig.main.row_hover_secondary_text) {
                    return {
                        color: this.$styleConfig.main.row_hover_secondary_text.value
                    }
                }

                if (this.$styleConfig.main.tertiary_text) {
                    return {
                        color: this.$styleConfig.main.tertiary_text.value
                    }
                }
            }
        },
        $cartRowItemStyle() {
            if (this.$styleConfig) {
                if (this.$data.$active.musicContainer && this.$styleConfig.main.row_active_background) {
                    return {
                        background: this.$styleConfig.main.row_active_background.value,
                        color: this.$styleConfig.main.row_active_secondary_text.value
                    }
                }

                if (this.$data.$hover.musicContainer && this.$styleConfig.main.row_hover_background) {
                    return {
                        background: this.$styleConfig.main.row_hover_background.value,
                        color: this.$styleConfig.main.row_hover_secondary_text.value
                    }
                }

                if (this.$styleConfig.main.secondary_text) {
                    return {
                        color: this.$styleConfig.main.secondary_text.value
                    }
                }
            }

            return {}
        },
        $musicContainerShadow() {
            // if (this.$styleConfig && this.$styleConfig.main.background != undefined) {
            //     let rgba = (this.isDarkColor(this.$styleConfig.main.background.value)) ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';
            //
            //     return {
            //         'box-shadow': `0 0 20px ${rgba}`
            //     }
            // }
        },
        $musicContainerOverlayStyle() {
            if (this.$styleConfig && this.$styleConfig.main.highlight_color != undefined) {
                let shade = this.shadeColor(this.$styleConfig.main.highlight_color.value, -0.3)

                return {
                    'background-image': `linear-gradient(135deg, ${this.$styleConfig.main.highlight_color.value} 0%, ${shade} 100%)`
                }
            }
        },
        $primaryMusicContainerOverlayStyle() {
            if (this.$styleConfig && this.$styleConfig.main.highlight_color != undefined) {
                return {
                    'background-image': `linear-gradient(180deg, ${this.$styleConfig.main.highlight_color.value}, rgba(58, 57, 133, 0) 100% )`
                }
            }

        },
        $dividerStyle() {
            if (this.$styleConfig && this.$styleConfig.main.background) {
                return {
                    'border-bottom': `1px solid ${this.borderHexColor}`
                }
            }

            return {}
        },
        $borderColorStyle() {
            if (this.$styleConfig && this.$styleConfig.main.background) {
                return {
                    'border-color': this.borderHexColor
                }
            }

            return {}
        },
        $transparentBorderColorStyle() {
            if (this.$styleConfig && this.$styleConfig.main.background) {
                let rgb = this.hexToRgb(this.borderHexColor)
                let background = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.36)`;
                return {
                    'border-color': background
                }
            }

            return {}
        },
        $menuBackgroundStyle() {
            if (this.$styleConfig && this.$styleConfig.menu.background != undefined) {
                return {
                    background: this.$styleConfig.menu.background.value
                }
            }
            return {}
        },
        $menuItemTextStyle() {
            if (this.$styleConfig) {
                if (this.$menuItemActive &&
                    this.$styleConfig.menu.item_active_text != undefined
                    && this.$styleConfig.menu.background.value) {

                    return {
                        'color': this.$styleConfig.menu.item_active_text.value,
                        'border-color': this.shadeColor(this.$styleConfig.menu.background.value, -0.1)
                    }
                } else if (this.$data.$hover.menuItem &&
                    this.$styleConfig.menu.item_hover_text != undefined) {

                    return {
                        'color': this.$styleConfig.menu.item_hover_text.value
                    }
                } else if (this.$styleConfig.menu.item_text != undefined) {

                    return {
                        color: this.$styleConfig.menu.item_text.value
                    }
                }
            }
            return {}
        },
        $menuItemStyle() {
            if (this.$styleConfig) {
                if (this.$menuItemActive &&
                    this.$styleConfig.menu.item_active_text != undefined) {

                    return {
                        'color': this.$styleConfig.menu.item_active_text.value
                    }
                }

                if (this.$data.$hover.menuItem &&
                    this.$styleConfig.menu.item_hover_text != undefined) {

                    return {
                        'color': this.$styleConfig.menu.item_hover_text.value
                    }
                }

                if (this.$styleConfig.menu.item_text != undefined) {
                    return {
                        color: this.$styleConfig.menu.item_text.value
                    }
                }
            }

            return {}
        },
        $menuItemIconStyle() {
            if (this.$styleConfig) {
                if (this.$menuItemActive &&
                    this.$styleConfig.menu.item_icon_active != undefined) {

                    return {
                        color: this.$styleConfig.menu.item_icon_active.value,
                        fill: this.$styleConfig.menu.item_icon_active.value
                    }
                }

                if (this.$data.$hover.menuItem &&
                    this.$styleConfig.menu.item_icon_hover != undefined) {

                    return {
                        color: this.$styleConfig.menu.item_icon_hover.value,
                        fill: this.$styleConfig.menu.item_icon_hover.value
                    }
                }

                if (this.$styleConfig.menu.item_icon != undefined) {
                    return {
                        color: this.$styleConfig.menu.item_icon.value,
                        fill: this.$styleConfig.menu.item_icon.value
                    }
                }
            }

            return {}
        },
        $menuItemActive() {
            if (this.item != undefined && this.item.id != undefined) {
                return this.$route.name == this.item.id
            }
        },
        $menuItemBorderColor() {
            if (this.$styleConfig && this.$styleConfig.menu.background != undefined) {
                return {
                    'border-color': this.shadeColor(this.$styleConfig.menu.background.value, -0.1)
                }
            }

            return {}
        },
        $playerMainStyle() {
            if (this.$styleConfig && this.$styleConfig.player.background != undefined && this.$styleConfig.player.primary_text != undefined) {
                return {
                    background: this.$styleConfig.player.background.value,
                    color: this.$styleConfig.player.primary_text.value
                }
            }

            return {}
        },
        $playerPrimaryTextStyle() {
            if (this.$styleConfig && this.$styleConfig.player.primary_text != undefined) {
                return {
                    color: this.$styleConfig.player.primary_text.value
                }
            }

            return {}
        },
        $playerSecondaryTextStyle() {
            if (this.$styleConfig && this.$styleConfig.player.secondary_text != undefined) {
                return {
                    color: this.$styleConfig.player.secondary_text.value
                }
            }
            return {}
        },
        $playerPlayButtonStyle() {
            if (this.$styleConfig && this.$styleConfig.player.play_button_background != undefined && this.$styleConfig.player.play_button_icon != undefined) {
                return {
                    'background-color': this.$styleConfig.player.play_button_background.value,
                    'border-color': this.$styleConfig.player.play_button_background.value,
                    'color': this.$styleConfig.player.play_button_icon.value,
                }
            }
        },
        $playerActiveIconsStyle() {
            if (this.$styleConfig && this.$styleConfig.player.icon_active != undefined) {
                return {
                    color: this.$styleConfig.player.icon_active.value,
                }
            }
        },
        $playerProgressContainerStyle() {
            if (this.$styleConfig && this.$styleConfig.player.background != undefined) {
                return {
                    background: this.shadeColor(this.$styleConfig.player.background.value, 0.1)
                }
            }
        },
        $playerProgressBarStyle() {
            if (this.$styleConfig && this.$styleConfig.player.progress_bar_background != undefined) {
                return {
                    background: this.$styleConfig.player.progress_bar_background.value
                }
            }
        },
        $progressBarIndicatorDarkStyle(){
            if (this.$styleConfig && this.$styleConfig.player.progress_bar_background != undefined) {
                return {
                    background: this.$styleConfig.player.progress_bar_background.value
                }
            }
        },
        $progressBarrIndicatorLiteStyle(){
            if (this.$styleConfig && this.$styleConfig.player.progress_bar_background != undefined) {
                let rgb = this.hexToRgb(this.$styleConfig.player.progress_bar_background.value)

                return {
                    'background': `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.4)`
                }
            }
        },
        $inputStyle() {
            if (this.$styleConfig && this.$styleConfig.main.background != undefined && this.$styleConfig.main.secondary_text != undefined) {
                let color = this.shadeColor(this.$styleConfig.main.background.value, 0.1)

                return {
                    'background-color': `${color} !important`,
                    'color': this.$styleConfig.main.secondary_text.value
                }
            }
        },
        $pageBackgroundOverlay() {
            if (this.$styleConfig && this.$styleConfig.main.background != undefined) {
                let rgb = this.hexToRgb(this.$styleConfig.main.background.value)

                return {
                    'background-image': `linear-gradient(180deg, rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0) 0%, ${this.$styleConfig.main.background.value} 100%)`
                }
            }
        },
        $licenseRowStyle() {
            if (this.$styleConfig) {
                let style = {}

                if (this.$styleConfig.main.container_background != undefined && this.$styleConfig.main.container_text != undefined) {
                    style['background-color'] = this.$styleConfig.main.container_background.value
                    style['color'] = this.$styleConfig.main.container_text.value
                }

                if (this.$highlightedLicenseGradient2 != undefined) {
                    let rgb = this.hexToRgb(this.$highlightedLicenseGradient2)
                    let background = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.22)`;
                    style['border-color'] =  background;
                }

                return style

            }
        },
        $highlightedLicenseGradient1() {
            if (this.$styleConfig && this.$styleConfig.main.highlighted_license_gradient_1 != undefined) {
                return this.$styleConfig.main.highlighted_license_gradient_1.value
            }
        },
        $highlightedLicenseGradient2() {
            if (this.$styleConfig && this.$styleConfig.main.highlighted_license_gradient_2 != undefined) {
                return this.$styleConfig.main.highlighted_license_gradient_2.value
            }
        },
        $highlightedLicenseTextColor() {
            return '#ffffff'
        },
        $gradientBackground() {
            if (this.$styleConfig && this.$styleConfig.main.highlighted_license != undefined) {
                let style = {}

                style['background-image'] = `linear-gradient(152deg, ${this.$highlightedLicenseGradient1} 0%, ${this.$highlightedLicenseGradient2} 100%)`
                style['color'] = '#ffffff'
                // style['border'] = 'none'

                return style

            }
        },
        $popupBackground() {
            if (this.$styleConfig) {
                let style = {}

                style['background-image'] = `linear-gradient(152deg, ${this.$styleConfig.main.highlighted_license.value[1]} 0%, ${this.$styleConfig.main.highlighted_license.value[1]} 100%)`

                return style

            }
        },
        $discountContainerStyle() {
            if (this.$styleConfig && this.$styleConfig.main.container_background != undefined && this.$styleConfig.main.container_text != undefined) {
                let style = {}

                if (this.$data.$active.discountContainer) {
                    style['background-image'] = `linear-gradient(152deg, ${this.$highlightedLicenseGradient1} 0%, ${this.$highlightedLicenseGradient2} 100%)`
                } else {
                    style['background-color'] = this.$styleConfig.main.container_background.value
                    // Add it as background image to ensure smooth color transition from active
                    style['background-image'] = `linear-gradient(${this.$styleConfig.main.container_background.value}, ${this.$styleConfig.main.container_background.value})`
                    style['color'] = this.$styleConfig.main.container_text.value
                }
                if (this.$highlightedLicenseGradient2 != undefined) {
                    let rgb = this.hexToRgb(this.$highlightedLicenseGradient2)
                    let border = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.22)`;
                    style['border-color'] =  border;
                }

                return style
            }
        },
        $linksNeedUpdating() {
            return this.$store.state.pagesConfigEdit.linksNeedUpdating
        },
        $viewPortWidth() {
            return this.$store.state.viewPortWidth
        },
        $currentRoutePageId() {
            let currentRoutePageId = (this.$route.matched[0].props.default != undefined &&
                this.$route.matched[0].props.default.pageId != undefined) ? this.$route.matched[0].props.default.pageId : false

            return currentRoutePageId
        },
        borderHexColor() {
            if (this.$styleConfig && this.$styleConfig.main.background) {
                let shadeValue = this.isDarkColor(this.$styleConfig.main.background.value) ? 0.1 : -0.1
                let color = this.shadeColor(this.$styleConfig.main.background.value, shadeValue)

                return color
            }
        },
        $visualiserColor() {
            if (this.$styleConfig && this.$styleConfig.player.visualiser_color != undefined) {
                return this.$styleConfig.player.visualiser_color.value
            }
        },
        $modalBackgroundStyle() {
            if (this.$styleConfig) {
                let rgb = this.hexToRgb(this.$styleConfig.main.background.value)
                return {
                    background: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.95)`,
                    color: this.$styleConfig.main.primary_text.value,
                }
            }
            return {}
        },
        $modalBackgroundStyleOpaque() {
            if (this.$styleConfig) {
                let rgb = this.hexToRgb(this.$styleConfig.main.background.value)
                return {
                    background: `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`
                }
            }
            return {}
        }

    },
    methods: {
        $buyButtonStyle(inCart) {
            if (inCart && this.$styleConfig && this.$styleConfig.main.button_background != undefined) {
                return {
                    'color': this.$styleConfig.main.button_background.value,
                    'background': this.$styleConfig.main.background.value
                }
            } else if (this.$styleConfig && this.$styleConfig.main.button_background != undefined) {
                return {
                    'background': this.$styleConfig.main.button_background.value,
                    'color': '#ffffff'
                }
            }

            return {}
        },
        $buyPriceStyle(inCart = false) {
            if (this.$styleConfig && this.$styleConfig.main.highlight_color != undefined) {
                return {
                    'color': this.$styleConfig.main.button_background.value
                }
            }

            return {}
        },
        $licenseDiscountsButtonStyle(inCart = false) {

            if (this.$styleConfig && this.$styleConfig.main.license_discounts_button_background != undefined) {

                if (inCart) {

                    return {
                        'color': this.$styleConfig.main.license_discounts_button_background.value,
                        'background': 'transparent',
                        'border-color': this.$transparentBorderColorStyle["border-color"]
                    }
                }

                return {
                    'background': this.$styleConfig.main.license_discounts_button_background.value,
                    'color': '#ffffff',
                    'border-color': this.$transparentBorderColorStyle["border-color"]
                }
            }

            return {}
        },
        $customBorderColor(shade) {
            if (this.$styleConfig && this.$styleConfig.main.background != undefined) {
                let shadeValue = this.isDarkColor(this.$styleConfig.main.background.value) ? shade : -shade
                let color = this.shadeColor(this.$styleConfig.main.background.value, shadeValue)

                return {
                    'border-color': color
                }
            }
        },
        $beatLicenseStyle(inCart = false) {
            if (this.$styleConfig && this.$styleConfig.main.background != undefined) {

                let style = {}

                if (inCart) {
                    style['background-image'] = `linear-gradient(152deg, ${this.$highlightedLicenseGradient1} 0%, ${this.$highlightedLicenseGradient2} 100%)`

                    if (!this.$data.$hover.beatLicense) {
                        style['border'] = 'none'
                    }
                } else {
                    style['background'] = this.$styleConfig.main.container_background.value
                    style['color'] = this.$styleConfig.main.container_text.value
                    style['border-color'] = this.borderHexColor
                }

                if (this.$data.$hover.beatLicense) {
                    style['border-color'] = this.$styleConfig.main.highlight_color.value
                }

                return style
            }
        },
        $iconColorStyle(active) {
            if (this.$styleConfig && this.$styleConfig.main.secondary_text != undefined) {
                if (active) {
                    return {
                        color: this.$styleConfig.main.secondary_text.value
                    }
                } else {
                    let shadeValue = this.isDarkColor(this.$styleConfig.main.secondary_text.value) ? 0.6 : -0.6
                    let color = this.shadeColor(this.$styleConfig.main.secondary_text.value, shadeValue)

                    return {
                        color: color
                    }
                }
            }
        },
        saveConfig() {
            if (!this.currentConfig) {
                return
            }
            this.$store.commit('toggleConfigLoading')
            this.$forceUpdate()

            let data = {
                username: this.$store.state.user.username
            };

            data = Object.assign(data, this.currentConfig)

            this.$http.put(`${ab.apiUrl}/infinity/config/${this.currentConfig.id}`, data,
                 {headers: {'Authorization': `Bearer ${ab.token}`}})
                .then((response) => {
                    if (this.$linksNeedUpdating || !this.currentConfig.hasIndexPage()) {

                        this.$router.push({query: Object.assign({}, this.$route.query), hash: 'config'})
                        location.reload()
                        return
                    }

                    this.$store.commit("discoverPageInitialLoad", {load: false})
                    let configuration = new Configuration(response.data.item)

                    this.$store.commit("currentConfig", {config: configuration})
                    swal({
                        title: "Success",
                        text: "Your configuration has been saved.",
                        icon: "success",
                        buttons: false,
                        timer: 2000,
                    })
                    this.$store.commit('toggleConfigLoading')

                    for (let i = 0; i < this.$store.state.userConfigs.length; i++) {
                        let userConfig = this.$store.state.userConfigs[i]

                        if (configuration.id === userConfig.id) {
                            userConfig.name = configuration.name
                        }
                    }

                }).catch((error) => {
                    swal({
                        title: "Oops! Something went wrong",
                        text: error.message,
                        icon: "warning",
                        buttons: false,
                        timer: 2000,
                    });
                    this.$store.commit('toggleConfigLoading')
                })
        },
        resetToDefault() {
            swal({
                title: "Are you sure?",
                text: "This will reset your configuration to the default Purple Clouds template with the pages for a full site.",
                icon: "warning",
                buttons: ['Cancel', 'Reset'],
                dangerMode: true,
            })
            .then((willDelete) => {
                if (willDelete) {
                    this.$store.commit('toggleConfigLoading')
                    var config = jQuery.extend(true, {}, ab.infinityDefaultConfiguration);
                    config.id = this.currentConfig.id
                    config.name = this.currentConfig.name
                    config.delete_logo = true
                    config.delete_hero = true
                    config.allowCoustomerLogin = true
                    document.title = config.storeTitle
                    let configuration = new Configuration(config)
                    this.updateLinks(configuration)

                    this.$store.commit("currentConfig", { config: configuration })
                    this.$store.commit('toggleConfigLoading')
                    this.$hasReset = true

                    this.$nextTick(() => {
                        // Link to second page and then home page otherwise direct link to home page results in error
                        this.$router.replace({name: configuration.pagesConfig[1].id, path: configuration.pagesConfig[1].link})
                        this.$router.replace({name: configuration.pagesConfig[0].id, path: configuration.pagesConfig[0].link})
                    })
                }
            });
        },
        updateLinks(configuration) {
            for (var i = 0; i < configuration.pagesConfig.length; i++) {
                let page = configuration.pagesConfig[i]
                const route  = generateRouteFromPage(page);
                this.$router.addRoutes([route]);
            }

        },
        updateCurrentRoutePath(page) {
            if (this.$currentRoutePageId && this.$currentRoutePageId == page.id) {
                this.$router.replace({link: page.link})
            }
        },
        shadeColor(color, percent) {
            let f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
            return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
        },
        isDarkColor(bgColor) {
            let color = this.hexToRgb(bgColor)
            return (((color.r * 0.299) + (color.g * 0.587) + (color.b * 0.114)) < 186)
        },
        hexToRgb(color) {
            let colorHex = (color.charAt(0) === '#') ? color.substring(1, 7) : color;

            return {
                r: parseInt(colorHex.substring(0, 2), 16), // hexToR,
                g: parseInt(colorHex.substring(2, 4), 16), // hexToG
                b: parseInt(colorHex.substring(4, 6), 16)  // hexToB
            }
        },
        generateShadeColor(sourceColor, shade) {
            let shadeValue = this.isDarkColor(sourceColor) ? shade : -shade
            return this.shadeColor(sourceColor, shadeValue);
        }
    },
}
